const initPartnershipFilters = () => {   
   const availableDirections = document.querySelectorAll("[data-available-direction]");
   const filters = document.querySelectorAll(".available [data-filter]");
   
   availableDirections.forEach((card) => {
      card.addEventListener("click", () => Array.from(filters).find((filter) => filter.dataset.direction === card.dataset.availableDirection).click())
   })
};
 
export default initPartnershipFilters;
